const TYPE = "[FAVORITES] ";

export default {
  ADD: `${TYPE} ADD`,
  REMOVE: `${TYPE} REMOVE`,
  UPDATE: `${TYPE} UPDATE`,
  EMPTY: `${TYPE} EMPTY`
};
